import { styled } from '@linaria/react'
import { PINLockPlayerWrapper } from 'blocks/Popup'
import { MEDIA } from 'vars/index'
import { LayoutBlockContentSC, LayoutBlockSC } from '../LayoutBlock.styled'

export const LayoutBlockPlayerSC = styled(LayoutBlockSC)<{
  miniPlayer: boolean
  visible: boolean
}>`
  overflow: hidden;
  padding-top: ${({ miniPlayer }) =>
    miniPlayer ? '0px' : 'var(${PAGE_NOTIFICATION.HEIGHT}, 0px)'};
  opacity: ${({ visible }) => (visible ? 1 : 0)};

  ${MEDIA.TOUCH} {
    &:not([data-mini-player='true']):not([data-autoplay-trailer='true']) {
      height: 100vh;
      min-height: 100vh;

      @supports (height: 100dvh) {
        height: 100dvh;
        min-height: 100dvh;
      }
    }
  }

  & ${LayoutBlockContentSC} {
    display: block;

    & ${PINLockPlayerWrapper} {
      position: absolute;
      transform: translate(-50%, -50%);
      left: 50%;
      top: 50%;
    }
  }
`
